import * as React from 'react';
import Box from '@mui/material/Box';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { styled } from '@mui/material/styles';

export default function CustomVerticalStepper({ currentDecision, totalDecisions }) {
  const stepHeight = 75 / totalDecisions; // Each step occupies part of 75vh
  const stepTop = (index) => `${(index * stepHeight)}vh`;

  return (
    <StepperContainer>
      {/* Arrow at the top */}
      <ArrowWrapper>
        <ArrowDropUpIcon fontSize="large" />
      </ArrowWrapper>

      <StepContentWrapper>
        {/* Dynamically render steps */}
        {Array.from({ length: totalDecisions }, (_, index) => (
          <StepBox
            key={index}
            isActive={currentDecision === index + 1}
            sx={{
              height: `${stepHeight}vh`, // Dynamic height for each step
              top: stepTop(index), // Dynamically set the top position
            }}
          />
        ))}
      </StepContentWrapper>

      {/* Arrow at the bottom */}
      <ArrowWrapper>
        <ArrowDropDownIcon fontSize="large" />
      </ArrowWrapper>
    </StepperContainer>
  );
}


const StepperContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '80vh', // Total height of 75vh
  border: '1px solid #626262',
  width: '30px',
  backgroundColor: '#f5f5f5',
  position: 'relative',
  overflow: 'hidden', // Prevent overflow outside the container
}));

const ArrowWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
});

const StepContentWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  position: 'relative',
  height: '100%',
});

const StepBox = styled(Box)({
  width: '26px',
  backgroundColor: '#e0e0e0',
  marginBottom: '4px',
  borderBottom: '1px solid #000',
  borderTop: '1px solid #000',
  position: 'absolute', // Absolutely positioned to allow dynamic movement
  transition: 'all 0.5s ease', // Smooth transition when moving between decisions
});
